import _Vue from "vue";
import EventBus from "@/utils/eventBus";
import { sendEvent } from "@/utils/analytics";
import store from "@/store";
import GeneralUtils from "@/utils/generalUtils";
import * as types from "@/store/constants/types";
import LaunchUtils from "@/utils/launchUtils";
import generalUtilsHelper from "@/utils/generalUtils";
import settingModule from "@/store/modules/settingDataModule";
import startUpPolicyModule from "@/store/modules/startUpPolicyModule";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY,
  RECORD_KEY
} from "@/utils/superPayAndBackUp";

// import { pageView } from "@/utils/analytics";
/**
 * 通过router钩子在执行前判断:to,from深度，来给予变量值; 钩子执行完后inserted钩子执行函数
 * @param Vue
 * @param router
 * @param options
 */

export function RouterTrasitionPlugin<RouterOption>(
  Vue: typeof _Vue,
  router: any,
  options?: RouterOption
): void {
  // let transOption: any = {
  //   sameDepthDisable: false,
  //   firstEntryDisable: false
  // };
  let transitionType: string;
  let lastPath: string;
  let toRoute: any;
  const staticRouters: any[] = [
    {
      name: "Followers"
    },
    {
      name: "Posts"
    },
    {
      name: "More"
    },
    {
      name: "EarnCoin"
    },
    {
      name: "CoinsContainer"
    }
  ];

  const handleRootRouter = async (to: any, from: any, next: any) => {
    const isVipPlanB = LaunchUtils.isVipPlanB();
    const isVip = GeneralUtils.isVip();

    /*
   * 如果配置了下架，欢迎页就是第一个，然后下架，然后vip
     如果没配置下架，vip第一个，欢迎页第二个
   * */

    if (store.state.startUpPolicyModule.settingExist) {
      store.state.startUpPolicyModule.startSettingExist = true;
    }
    store.state.startUpPolicyModule.hasRedirect = generalUtilsHelper.hasRedirect();
    store.state.startUpPolicyModule.isRedirect = generalUtilsHelper.isRedirect();

    // 如果是空账号，without_welcome为false,vip_before_welcome为true , 先展示vip再展示welcome
    if (store.state.startUpPolicyModule.isRedirect) {
      if (LaunchUtils.needShowWelcome()) {
        // console.log('needShowWelcome');
        store.dispatch(types.ROUTER_PUSH, LaunchUtils.rootSplashRoute());
        next();
        return;
      }

      if (!isVip && LaunchUtils.vipBeforeWelcome()) {
        await store.dispatch(types.ROUTER_PUSH, LaunchUtils.rootMainRoute());
        store.dispatch(types.INITIAL_HANDLE_ROUTER);
        // next(LaunchUtils.rootVipRoute());
        next();
        return;
      }
    } else {
      console.log(
        "!isVip && LaunchUtils.vipBeforeWelcome()",
        !isVip && LaunchUtils.vipBeforeWelcome()
      );

      const superPayLaunchEnable = store.getters[
        types.GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE
      ]();

      if (!isVip && LaunchUtils.vipBeforeWelcome() && !superPayLaunchEnable) {
        store.dispatch(types.ROUTER_PUSH, LaunchUtils.rootVipRoute());
        // next(LaunchUtils.rootVipRoute());
        next();
        return;
      }

      if (LaunchUtils.needShowWelcome()) {
        // console.log('needShowWelcome');
        store.dispatch(types.ROUTER_PUSH, LaunchUtils.rootSplashRoute());
        next();
        return;
      }
    }

    // next(LaunchUtils.rootMainRoute());
    await store.dispatch(types.ROUTER_PUSH, LaunchUtils.rootMainRoute());
    store.dispatch(types.INITIAL_HANDLE_ROUTER);
    next();
  };

  /**
   *  需要缓存经过的子路由，在下次其他的跳转进入后重定向
   */
  const routerRedirect = (to: any, from: any, next: any) => {
    if (to.name === from.name && from.name !== "OrderDetail") {
      console.log("重复跳转相同的路由");
      return;
    }

    if (from.path === "/" && to.path === "/Home") {
      handleRootRouter(to, from, next);
      return;
    }

    const isVipPlanB = LaunchUtils.isVipPlanB();

    if (
      (to.name === "VipCenter" && to.query.type === "single") ||
      to.name === "VipCenterPlanB"
    ) {
      //记录跳转vip的次数，因为有的是一开始就是vip,避免不了:
      console.log("记录跳转vip的次数，因为有的是一开始就是vip,避免不了");
      SuperPayAndBackUpHelpers.addTempKeyTimes(TEMP_KEY.VIP_CENTER_SHOW_TIMES);
      //堆栈记录：
      const launchIndex = store.getters[types.GETTER_APP_LAUNCH_TIME];
      SuperPayAndBackUpHelpers.pushRecord(
        RECORD_KEY.LAUNCH_PAGE_SUPER_OR_BACK_OR_VIP_SHOW_RECORD,
        {
          name: "vip",
          index: launchIndex
        }
      );
    }

    if (to.name === "VipCenter" && to.query.type === "single" && isVipPlanB) {
      next({ name: "VipCenterPlanB", params: to.params, query: to.query });
      return;
    }

    next();
  };

  router.beforeEach((to: any, from: any, next: any) => {
    console.info("Router Change:", {
      to,
      from,
      next
    });
    // pageView(to.path);
    try {
      toRoute = to;
      let toDepth = to.path.split("/").length;
      let fromDepth = from.path.split("/").length;
      if (to.path.charAt(to.path.length - 1) !== "/") {
        toDepth += 1;
      }
      if (from.path.charAt(from.path.length - 1) !== "/") {
        fromDepth += 1;
      }
      transitionType = toDepth > fromDepth ? "forward" : "back";

      //深度相同
      if (toDepth === fromDepth) {
        if (lastPath === to.path) {
          transitionType = "back";
        } else {
          transitionType = "forward";
        }

        lastPath = from.path;
      }

      //首次进入无效果
      if (to.path === from.path && to.path === lastPath) {
        transitionType = "first";
      }

      //检测如果instance中包含routerTransitionConfig，则从instace中获取
      if (to.params.hasOwnProperty("routerTransition")) {
        transitionType = to.params.routerTransition;
      } else if (from.params.hasOwnProperty("routerTransition")) {
        //如果当前的路由发现有params transition，则需要相反的方向进行过渡动画
        const transtion = from.params.routerTransition;
        switch (transtion) {
          case "forward":
            transitionType = "back";
            break;
          case "back":
            transitionType = "forward";
            break;
          case "up":
            transitionType = "down";
            break;
          case "down":
            transitionType = "up";
            break;
          case "fadeOut":
            transitionType = "fadeIn";
            break;
          case "fadeIn":
            transitionType = "fadeOut";
            break;
          default:
            break;
        }
      }

      //如果在规定返回内的路由,来去路由都在规定数组内
      const toRouter = staticRouters.find((torouter: any) => {
        return torouter.name === to.name;
      });
      const fromRouter = staticRouters.find((frouter: any) => {
        return frouter.name === from.name;
      });
      if (fromRouter && toRouter) {
        transitionType = "static";
      }

      routerRedirect(to, from, next);

      EventBus.$emit("router-transition-type", transitionType);

      //打点:
      if (to.name === "Followers") {
        sendEvent("uia_tab_page_show", "follow");
      } else if (to.name === "Posts") {
        sendEvent("uia_tab_page_show", "like");
      } else if (to.name === "EarnCoin") {
        sendEvent("uia_tab_page_show", "earn_coins");
      } else if (to.name === "CoinsContainer") {
        sendEvent("uia_tab_page_show", "coin_store");
      } else if (to.name === "More") {
        sendEvent("uia_tab_page_show", "me");
      }
    } catch (error) {
      console.warn("router.beforeEach ERROR:", error);
      next();
    }
  });
}
